module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/recommend_3_03-af77689884d2e05e26fb605017c16b75.jpg";